module.exports = __webpack_public_path__ + "img/top-img.694a87db.png";